import CodeMirror from 'codemirror';
import { ICustomProperty } from '../../index.d';
import { getPrevEffectiveToken, hasTokenIncludes } from '../../utils/codemirror';


export function getCurrentMemberGradeId(
    editor: CodeMirror.Editor,
    pos: CodeMirror.Position,
    gradeIds: number[],
    customProperties: ICustomProperty[]
) {

    const currentToken = editor.getTokenAt(pos);

    try {
        const prev1Token = getPrevEffectiveToken(editor, currentToken)!;
        const prev2Token = getPrevEffectiveToken(editor, prev1Token)!;

        const prev2TokenTypes = (prev2Token.type || '').split(' ');

        let gradeId;

        // 判断是否为自定义属性
        if (prev2TokenTypes.includes('custom-property-id')) {
            const customPropertyId = Number(prev2Token.string.replace(/[\{\}]/g, ''));
            const customProperty = customProperties.find(item => item.id === customPropertyId);
            if (customProperty) {
                gradeId = matchExpressionGradeId(customProperty.expression);
            }
        } else if (prev2TokenTypes.includes('CURRENT_MEMBER_GRADE')) {
            gradeId = matchExpressionGradeId(prev2Token.string);
        }

        if (gradeId && gradeIds.includes(gradeId)) {
            if (
                hasTokenIncludes(prev1Token, ['operator']) && (
                    prev1Token.string === '==' || prev1Token.string === '!='
                )
            ) {
                return { id: gradeId, isMultiple: false };
            } else if (
                hasTokenIncludes(prev1Token, ['operator', 'IN']) ||
                hasTokenIncludes(prev1Token, ['operator', 'NOT-IN'])) {
                return { id: gradeId, isMultiple: true };
            }
        }

        return false;
    }
    catch (err) {
        return false;
    }
}

function matchExpressionGradeId(expression: string) {
    const matched = expression.match(/^CURRENT_MEMBER_GRADE\((\d+)\)$/i);
    return matched ? Number(matched[1]) : null;
}
